import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src453302789/src/src/app/ui/common/side-menu.tsx");
